import { Color } from './color';
/**
 * ▲
 */
export const Triangle = (options, context) => {
    return Color(Object.assign({ colorAttribute: 'fill', symbol: 'triangle' }, options), context);
};
Triangle.props = Object.assign({ defaultMarker: 'triangle' }, Color.props);
//# sourceMappingURL=triangle.js.map